/* eslint-disable */
import type { RateTypeV1 } from '../hotel/hotel_common';

export interface HotelPref {
  /** Preferred hotel chains. */
  hotelParentChains: HotelChain[];
  /** Preferred hotel brands. */
  hotelBrands: HotelBrand[];
  /** Preferred hotel amenities. */
  hotelPrefAmenities: HotelPrefHotelPrefAmenity[];
  /** Preferred room options. */
  roomPreference?: RoomPreference;
  /** Preferred rate types. */
  rateTypes: RateTypeV1[];
}

export enum HotelPrefHotelPrefAmenity {
  HOTEL_PREF_AMENITY_UNKNOWN = 0,
  PARKING = 1,
  FREE_PARKING = 2,
  FREE_BREAKFAST = 3,
  POOL = 4,
  WIFI = 5,
  FITNESS_CENTER = 6,
  FAMILY_FRIENDLY = 7,
  RECEPTION = 8,
  SPA = 9,
  RESTAURANT = 10,
  BAR = 11,
  TRANSPORTATION = 12,
  PET_FRIENDLY = 13,
  BUSINESS_CENTER = 14,
  AIR_CONDITIONING = 15,
  BEACH_ACCESS = 16,
  LAUNDRY_SERVICES = 17,
  ROOM_SERVICE = 18,
  ACCESSIBLE = 19,
  UNRECOGNIZED = -1,
}

export interface HotelChain {
  chainName: string;
  chainCode: string;
}

export interface HotelBrand {
  brandName: string;
  brandCode: string;
}

export interface RoomPreference {
  isMobilityAccessible: boolean;
  bedCount: RoomPreferenceBedCount;
  roomType: RoomPreferenceRoomType;
  mostImportantFact: RoomPreferenceMostImportantFact;
  roomLocation: RoomPreferenceRoomLocation;
  pillowType: RoomPreferencePillowType;
  roomAmenityPrefs: RoomPreferenceRoomAmenityPref[];
}

/** Single choice for BedCount. */
export enum RoomPreferenceBedCount {
  BED_COUNT_UNKNOWN = 0,
  ONE_BED = 1,
  TWO_BEDS = 2,
  UNRECOGNIZED = -1,
}

/** Single choice for RoomType. */
export enum RoomPreferenceRoomType {
  ROOM_TYPE_UNKNOWN = 0,
  SMOKING = 1,
  NON_SMOKING = 2,
  UNRECOGNIZED = -1,
}

/** Single choice for MostImportantFact. */
export enum RoomPreferenceMostImportantFact {
  MOST_IMPORTANT_FACT_UNKNOWN = 0,
  ROOM_TYPE = 1,
  BED_COUNT = 2,
  ROOM_LOCATION = 3,
  UNRECOGNIZED = -1,
}

/** Single choice for RoomLocation. */
export enum RoomPreferenceRoomLocation {
  ROOM_LOCATION_UNKNOWN = 0,
  HIGH_FLOOR = 1,
  LOW_FLOOR = 2,
  NEAR_ELEVATOR = 3,
  UNRECOGNIZED = -1,
}

/** Multiple choice for RoomAmenity. */
export enum RoomPreferenceRoomAmenityPref {
  ROOM_AMENITY_UNKNOWN = 0,
  FEATHER_FREE_ROOM = 1,
  EXTRA_TOWELS = 2,
  REFRIGERATOR = 3,
  UNRECOGNIZED = -1,
}

/** Single choice for PillowType. */
export enum RoomPreferencePillowType {
  PILLOW_TYPE_UNKNOWN = 0,
  FOAM = 1,
  EXTRA_FOAM = 2,
  EXTRA_FEATHER = 3,
  UNRECOGNIZED = -1,
}
